import { render, staticRenderFns } from "./RegisterPageLayout.vue?vue&type=template&id=145d5f18&"
import script from "./RegisterPageLayout.vue?vue&type=script&lang=js&"
export * from "./RegisterPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPageLayout.vue?vue&type=style&index=0&id=145d5f18&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145d5f18')) {
      api.createRecord('145d5f18', component.options)
    } else {
      api.reload('145d5f18', component.options)
    }
    module.hot.accept("./RegisterPageLayout.vue?vue&type=template&id=145d5f18&", function () {
      api.rerender('145d5f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/components/RegisterPageLayout.vue"
export default component.exports